/**
 * EU Financial Authorities and Regulators Data
 * Comprehensive directory of regulatory bodies overseeing EU financial markets
 */

export const authorities = [
  {
    id: 'esma',
    code: 'ESMA',
    fullName: 'European Securities and Markets Authority',
    description: 'Independent EU Authority that contributes to safeguarding the stability of the European Union\'s financial system by enhancing the protection of investors and promoting stable and orderly financial markets.',
    established: '2011',
    headquarters: 'Paris, France',
    responsibilities: [
      'Securities markets regulation',
      'Investment protection',
      'Market integrity and transparency',
      'Credit rating agencies supervision',
      'Trade repositories oversight'
    ],
    frameworks: ['MiCA', 'DORA', 'MiFID II', 'EMIR', 'CSDR'],
    website: 'https://www.esma.europa.eu',
    email: 'info@esma.europa.eu',
    type: 'ESA',
    category: 'Securities & Markets'
  },
  {
    id: 'eba',
    code: 'EBA',
    fullName: 'European Banking Authority',
    description: 'Independent EU Authority working to ensure effective and consistent prudential regulation and supervision across the European banking sector.',
    established: '2011',
    headquarters: 'Paris, France',
    responsibilities: [
      'Banking regulation and supervision',
      'Consumer protection in banking',
      'Payment services oversight',
      'Anti-money laundering standards',
      'Stress testing coordination'
    ],
    frameworks: ['DORA', 'PSD3', 'AMLR', 'CRD/CRR', 'BRRD'],
    website: 'https://www.eba.europa.eu',
    email: 'info@eba.europa.eu',
    type: 'ESA',
    category: 'Banking'
  },
  {
    id: 'eiopa',
    code: 'EIOPA',
    fullName: 'European Insurance and Occupational Pensions Authority',
    description: 'Independent advisory body to the European Parliament, the Council of the European Union and the European Commission on insurance, reinsurance and occupational pensions matters.',
    established: '2011',
    headquarters: 'Frankfurt, Germany',
    responsibilities: [
      'Insurance and reinsurance regulation',
      'Occupational pensions supervision',
      'Consumer protection in insurance',
      'Financial stability monitoring',
      'Solvency II implementation'
    ],
    frameworks: ['DORA', 'Solvency II', 'IDD', 'IORP II'],
    website: 'https://www.eiopa.europa.eu',
    email: 'info@eiopa.europa.eu',
    type: 'ESA',
    category: 'Insurance & Pensions'
  },
  {
    id: 'ecb',
    code: 'ECB',
    fullName: 'European Central Bank',
    description: 'Central bank for the euro and administers monetary policy of the EU member states which comprise the eurozone. One of the world\'s most important central banks with responsibility for banking supervision through the Single Supervisory Mechanism.',
    established: '1998',
    headquarters: 'Frankfurt, Germany',
    responsibilities: [
      'Monetary policy for the eurozone',
      'Banking supervision (SSM)',
      'Financial stability oversight',
      'Payment systems infrastructure',
      'Foreign exchange operations'
    ],
    frameworks: ['CRD/CRR', 'BRRD', 'DORA'],
    website: 'https://www.ecb.europa.eu',
    email: 'info@ecb.europa.eu',
    type: 'Central Bank',
    category: 'Monetary & Banking'
  },
  {
    id: 'edpb',
    code: 'EDPB',
    fullName: 'European Data Protection Board',
    description: 'Independent European body which contributes to the consistent application of data protection rules throughout the European Union and promotes cooperation between the EU\'s data protection authorities.',
    established: '2018',
    headquarters: 'Brussels, Belgium',
    responsibilities: [
      'GDPR implementation guidance',
      'Data protection consistency',
      'Cross-border enforcement cooperation',
      'Privacy policy recommendations',
      'Data protection innovation'
    ],
    frameworks: ['GDPR', 'ePrivacy', 'Data Act'],
    website: 'https://edpb.europa.eu',
    email: 'edpb@edpb.europa.eu',
    type: 'Data Protection',
    category: 'Privacy & Data'
  },
  {
    id: 'enisa',
    code: 'ENISA',
    fullName: 'European Union Agency for Cybersecurity',
    description: 'EU agency dedicated to achieving a high common level of cybersecurity across Europe. Contributes to EU cyber policy, enhances the trustworthiness of ICT products, services and processes.',
    established: '2004',
    headquarters: 'Athens, Greece',
    responsibilities: [
      'Cybersecurity policy development',
      'NIS2 Directive implementation',
      'Incident response coordination',
      'Certification frameworks',
      'Cyber threat intelligence'
    ],
    frameworks: ['NIS2', 'DORA', 'Cybersecurity Act'],
    website: 'https://www.enisa.europa.eu',
    email: 'info@enisa.europa.eu',
    type: 'Cybersecurity',
    category: 'Cybersecurity'
  },
  {
    id: 'ec',
    code: 'EC',
    fullName: 'European Commission',
    description: 'Politically independent executive arm of the EU responsible for proposing legislation, implementing decisions, upholding EU treaties and managing the day-to-day business of the EU.',
    established: '1958',
    headquarters: 'Brussels, Belgium',
    responsibilities: [
      'Legislative proposals',
      'Policy implementation',
      'Treaty enforcement',
      'EU budget management',
      'External representation'
    ],
    frameworks: ['MiCA', 'DORA', 'PSD3', 'AMLR', 'GDPR', 'NIS2'],
    website: 'https://commission.europa.eu',
    email: null,
    type: 'Executive',
    category: 'Governance'
  },
  {
    id: 'srb',
    code: 'SRB',
    fullName: 'Single Resolution Board',
    description: 'Central resolution authority within the Banking Union, responsible for ensuring the orderly resolution of failing banks with minimum impact on the real economy and public finances.',
    established: '2015',
    headquarters: 'Brussels, Belgium',
    responsibilities: [
      'Bank resolution planning',
      'Resolution fund management',
      'Crisis management',
      'Systemic risk mitigation',
      'Cross-border coordination'
    ],
    frameworks: ['BRRD', 'SRMR', 'DORA'],
    website: 'https://www.srb.europa.eu',
    email: 'info@srb.europa.eu',
    type: 'Resolution',
    category: 'Banking'
  }
];

export const authorityCategories = [
  'All',
  'Securities & Markets',
  'Banking',
  'Insurance & Pensions',
  'Monetary & Banking',
  'Privacy & Data',
  'Cybersecurity',
  'Governance',
  'Resolution'
];

export const authorityTypes = [
  'All',
  'ESA',
  'Central Bank',
  'Data Protection',
  'Cybersecurity',
  'Executive',
  'Resolution'
];
